import { UploadFile } from 'components/Upload';
import { ProtoObject } from 'types/common';
import { IFileType } from 'types/types/common';
import { generateUid } from 'utils';
import { getUrlWithToken } from 'api/helpers';

export const convertFile = (file: any): UploadFile => ({
  uid: file.id ? String(file.id) : generateUid(),
  name: file.name || file.originalFilename,
  size: file.size,
  type: file.documentType,
  status: 'done',
  url: file.document,
});

export const convertFileList = (fileList?: IFileType[] | ProtoObject): UploadFile[] => {
  return fileList && Array.isArray(fileList) ? fileList.map(convertFile) : [];
};

export const downloadFileByLink = (fileName: string | undefined, fileLink: string) => {
  const link = document.createElement('a');
  if (fileName) link.download = fileName;
  link.href = getUrlWithToken(fileLink);
  link.click();
};
